<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="image" src="Images/titles.jpg"/></p>
<h1 class="h1"><a id="page_ii"></a><a id="page_iii"></a>OUR PRINCE OF SCRIBES</h1>
<p class="subtitle">Writers Remember Pat Conroy</p>
<p class="author"><span class="small">EDITED BY</span> Nicole Seitz and Jonathan Haupt<br/>
<span class="small">FOREWORD BY</span> Barbra Streisand<br/>
<span class="small">AFTERWORD BY</span> Cassandra King Conroy</p>
<p class="pub"><img alt="image" src="Images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?20bf6032